export const routes = {
  home: "/",
  about: "/about",
  term: "/terms-of-service",
  privacy: "/privacy-policy",
  auth: {
    login: "/auth/login",
    signup: "/auth/signup",
    register: "/auth/signup/info",
    forgot: "/auth/forgot",
    businessSignup: `https://${process.env.BUSINESS_DOMAIN}/auth/signup`,
  },
  job: {
    index: "/job",
    detail: "/job/:slug",
    detailPath: "/job/",
    category: "/job/category/:slug",
    categoryPath: "/job/category/",
  },
  company: {
    index: "/company",
    list: "/companies",
    detail: "/companies/:slug",
    detailPath: "/companies/",
  },
  interviewer: {
    index: "/interviewer",
  },
  candidate: {
    index: "/candidate",
    profile: "/candidate/profile",
    jobs: "/candidate/jobs",
    message: "/candidate/messages",
    refer: "/candidate/refer",
    setting: "/candidate/setting",
    notification: "/candidate/notification",
    interview: {
      schedules: "/candidate/interview/schedules",
    },
    work: {
      history: "/candidate/work/history",
    },
    sharedProfile: "/p/:sessionId",
    sharedProfilePath: "/p/",
  },
};

export const publicRoutes = [
  routes.home,
  routes.about,
  routes.term,
  routes.privacy,
  routes.auth.login,
  routes.auth.signup,
  routes.auth.register,
  routes.auth.forgot,
  routes.job.index,
  routes.job.detailPath + "*",
  routes.job.categoryPath + "*",
  routes.company.index,
  routes.company.list,
  routes.company.detailPath + "*",
  routes.candidate.sharedProfilePath + "*",
];

export const privateRoutes = [
  routes.candidate.profile,
  routes.candidate.jobs,
  routes.candidate.message,
  routes.candidate.refer,
  routes.candidate.setting,
  routes.candidate.notification,
  routes.candidate.interview.schedules,
  routes.candidate.work.history,
];
